import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Modal } from "@pd/pd-ui-kit";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useGetAllCoursesForSelect } from "~/entity/Courses/hooks/useGetAllCoursesForSelect";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { Field } from "~/shared/ui/Field";
import {
  addCourseValidationSchema,
  TAddCourseForm,
} from "~/widgets/Modals/AddEducationalProgramCourse/model/config";

const addCourseFormId = "AddEducationalProgramCourseForm";

interface IAddEducationalProgramCourseProps {
  isLoading?: boolean;
  onSubmit: (value: TAddCourseForm) => void;
}

export const AddEducationalProgramCourse = ({
  isLoading,
  onSubmit,
}: IAddEducationalProgramCourseProps) => {
  const { t } = useTranslation();
  const { openChildModal } = useGetLocationData();
  // Открытие/закрытие модалки — через replace, чтобы не плодить историю браузера
  const setDataReplace = useSetLocationData(true);

  const { control, handleSubmit, errors } = useForm<TAddCourseForm>({
    resolver: yupResolver(addCourseValidationSchema(t)),
  });

  const { courses, loading, onScrollBottomCourses, searchCourses } =
    useGetAllCoursesForSelect();

  const handleCloseModal = () => setDataReplace("openChildModal", "");

  const handlePopupScroll: React.UIEventHandler<HTMLDivElement> = (e) => {
    const target = e.currentTarget;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - 16) {
      onScrollBottomCourses();
    }
  };

  return (
    <Modal
      open={openChildModal === "addCourse"}
      title={t("patp.add_course_to_program")}
      onCancel={handleCloseModal}
      closable
      centered
      destroyOnHidden
      cancelButton={{ children: t("ui.cancel"), disabled: isLoading }}
      okButton={{
        htmlType: "submit",
        form: addCourseFormId,
        children: t("ui.save"),
        disabled: isLoading,
      }}
    >
      <form id={addCourseFormId} onSubmit={handleSubmit(onSubmit)}>
        <Field
          type="select"
          name="course"
          control={control}
          label={t("patp.course")}
          // «Обход заглушки»: в список курсов подмешивается служебная опция
          // с value === undefined — убираем её, как в useStaffFilterData
          options={courses.filter((el) => el.value !== undefined)}
          loading={loading}
          showSearch
          filterOption={false}
          onSearch={searchCourses}
          onPopupScroll={handlePopupScroll}
          error={errors["course"]?.message}
        />
      </form>
    </Modal>
  );
};
